import styles from "./FullScreenIframe.module.scss";

export default function FullScreenIframe({
  url,
  title,
}: {
  url: string;
  title: string;
}) {
  return (
    <div className={styles.container}>
      <iframe src={url} title={title} />
    </div>
  );
}
